import Vue from "vue";
import "./pollyfills";
import VueRouter from "vue-router";
import VueNotify from "vue-notifyjs";
import VeeValidate from "vee-validate";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import App from "./App.vue";

import GlobalComponents from "./gloablComponents";
import GlobalDirectives from "./globalDirectives";
import GlobalMixins from "./globalMixins";

import SideBar from "./components/UIComponents/SidebarPlugin";

import routes, { guardRoutes } from "./routes";
import store from "./store";

import "./assets/sass/paper-dashboard.scss";
import "./assets/sass/element_variables.scss";

import sidebarLinks from "./sidebarLinks";

import VModal from "vue-js-modal";

import VueWait from 'vue-wait';

import Hotjar from 'vue-hotjar';

import VueProgressBar from 'vue-progressbar';

Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '25px'
});

Vue.use(VueRouter);
Vue.use(GlobalDirectives);
Vue.use(GlobalComponents);
Vue.use(VueNotify);
Vue.use(SideBar, { sidebarLinks: sidebarLinks });
Vue.use(VeeValidate);
Vue.use(VueWait);

Vue.use (Hotjar, {
  id: process.env.VUE_APP_HOTJAR_ID,
  snippetVersion: Number(process.env.VUE_APP_HOTJAR_VERSION),
  isProduction: process.env.NODE_ENV === 'production',
})

Vue.use(VModal, {
  dynamicDefaults: {
    height: 'auto',
    scrollable: true,
    adaptive: true
  }
});

Vue.mixin({
  mounted() {
    // console.log("Mixin Mounted");
  },
  methods: GlobalMixins
});
locale.use(lang);

const router = new VueRouter({
  routes: routes.routes,
  linkActiveClass: "active"
});

router.beforeEach(guardRoutes);

// TODO: use new vue 3 version
Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store,
  wait: new VueWait(),
});
